module.exports = function(bootstrap) {
	bootstrap.run(["Service", "services", function (Service, services) {
		new Service({
			name: 'getTransactionHistoryService',
			group: "dpsext",
			url: "/dpsext/x-services/spendingAcct/v1/transactions",
			contentType: 'application/json',
			fetch: function(payload) {
				this.payload = payload;
				return this.get(this.payload);
			}
		});
	}]);
};